var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWorldPay = function SvgWorldPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-71.461%",
    y1: "103.089%",
    x2: "186.874%",
    y2: "3.837%",
    id: "world-pay_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#782B8F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2238D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-137.554%",
    y1: "116.606%",
    x2: "117.741%",
    y2: "17.354%",
    id: "world-pay_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#782B8F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2238D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-20.809%",
    y1: "69.322%",
    x2: "242.356%",
    y2: "-29.93%",
    id: "world-pay_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#782B8F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2238D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "196.188%",
    y1: "45.259%",
    x2: "-77.672%",
    y2: "54.14%",
    id: "world-pay_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#782B8F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2238D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "196.19%",
    y1: "45.259%",
    x2: "-77.67%",
    y2: "54.14%",
    id: "world-pay_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#782B8F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2238D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "196.19%",
    y1: "45.257%",
    x2: "-77.671%",
    y2: "54.142%",
    id: "world-pay_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#782B8F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2238D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "world-pay_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#782B8F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2238D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.86 0c.44 0 .628.206.691.618l2.199 12.764c.063.391-.084.618-.524.618h-2.282c-.44 0-.608-.227-.67-.618l-.294-1.976h-3.476l-.796 1.976c-.147.391-.356.618-.796.618h-2.157c-.419 0-.545-.227-.377-.618L17.739.618c.189-.433.42-.618.859-.618h2.262Zm-1.445 7.618c-.21-1.606-.168-2.965-.126-4.324-.314 1.359-.733 3.109-1.236 4.324l-.46 1.111h1.969l-.147-1.111Z",
    fill: "url(#world-pay_svg__a)",
    transform: "translate(1 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.404 4.715c.084.35.147.72.21 1.235.21-.535.377-.906.565-1.235L32.441.618c.189-.35.377-.618.817-.618h2.262c.44 0 .607.227.377.618l-4.859 8.194-.587 4.57c-.062.433-.209.618-.649.618H27.54c-.44 0-.607-.185-.544-.618l.524-4.159L24.713.618c-.125-.37.084-.618.524-.618h2.513c.44 0 .586.247.67.618l.984 4.097Z",
    fill: "url(#world-pay_svg__b)",
    transform: "translate(1 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.462 0H4.064c-.44 0-.629.185-.691.618l-.181 1.45a.638.638 0 0 0 .64.711h4.483c1.257 0 1.675.453 1.675 1.256 0 .062 0 .186-.02.37l-.105.845c-.126.947-.985 1.215-2.074 1.215H3.214c-.326 0-.6.239-.64.557l-.793 6.36c-.042.412.104.618.544.618h2.262c.44 0 .587-.185.65-.618l.523-4.138h1.78c4.063 0 5.424-1.4 5.655-3.397l.21-1.894c.041-.33.041-.453.041-.638C13.446 1.565 12.043 0 8.462 0Z",
    fill: "url(#world-pay_svg__c)",
    transform: "translate(1 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.639 0h-5.4a.355.355 0 0 0-.357.352c0 .194.16.351.357.351h5.4a.355.355 0 0 0 .358-.351A.355.355 0 0 0 8.639 0Z",
    fill: "url(#world-pay_svg__d)",
    transform: "translate(1 11.27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.198 1h-5.4a.355.355 0 0 0-.357.352c0 .194.16.351.358.351h5.4a.355.355 0 0 0 .357-.351A.355.355 0 0 0 7.198 1Z",
    fill: "url(#world-pay_svg__e)",
    transform: "translate(1 11.27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.757 2h-5.4A.355.355 0 0 0 0 2.352c0 .194.16.352.358.352h5.4a.355.355 0 0 0 .357-.352A.355.355 0 0 0 5.757 2Z",
    fill: "url(#world-pay_svg__f)",
    transform: "translate(1 11.27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.197.13c.07 0 .111.07.095.131L7.865 5.783a.112.112 0 0 1-.102.08H5.405a.107.107 0 0 1-.1-.08L4.689 3.23c-.018-.076-.057-.077-.077 0l-.596 2.552a.101.101 0 0 1-.1.081H1.52a.106.106 0 0 1-.102-.08L.002.253C-.01.205.025.13.102.13h2.344c.043 0 .086.026.098.088l.494 2.717c.012.069.07.069.082-.002L3.647.214c.01-.046.045-.085.1-.085h1.838a.1.1 0 0 1 .097.083l.5 2.722c.012.069.061.069.074 0L6.791.211A.104.104 0 0 1 6.887.13h2.31Zm15.866 5.63c0 .055.044.103.1.103h5.457c.062 0 .101-.051.101-.101V4.006c0-.062-.046-.107-.1-.107h-3.292c-.025 0-.05-.021-.05-.049V.237a.103.103 0 0 0-.1-.108h-2.015a.103.103 0 0 0-.1.106V5.76ZM38 3.004c0 1.152-.187 2.215-1.185 2.626-.578.242-1.795.322-2.372.322-1.105 0-2.225-.06-3.081-.16-.027-.003-.08-.04-.08-.1V.315c0-.061.043-.1.091-.105 0 0 1.136-.119 3.07-.151.577-.01 1.71.021 2.372.31C37.805.804 38 1.854 38 3.005m-4.517.916c0 .046.003.077.08.08 0 0 .598.036.957.036 1.07 0 1.148-.218 1.148-1 0-.78-.079-.998-1.148-.998-.345 0-.726.014-.992.036a.052.052 0 0 0-.045.053V3.92m-19.164-.883c0 .877-.196 1.167-1.202 1.167s-1.21-.29-1.21-1.167c0-.879.204-1.168 1.21-1.168s1.202.29 1.202 1.168m2.387-.04c0-1.152-.188-2.272-1.186-2.682C15.051.12 14.232 0 13.109 0c-1.124 0-1.95.121-2.419.315-.999.41-1.186 1.53-1.186 2.682 0 1.15.187 2.278 1.186 2.689.468.194 1.295.314 2.419.314 1.123 0 1.942-.12 2.411-.314.998-.41 1.186-1.538 1.186-2.69m7.752 2.69c.037.038.04.094.02.125-.02.033-.047.054-.09.054H21.76a.087.087 0 0 1-.068-.032c-.568-.665-1.972-1.906-1.979-1.912-.018-.017-.042-.022-.06-.008-.025.016-.025.044-.025.044v1.805a.1.1 0 0 1-.099.101l-2.018.001c-.06 0-.1-.051-.1-.102V.177a.103.103 0 0 1 .092-.101s4.563-.151 5.427.11c.973.294 1.162 1.03 1.162 1.836 0 .735-.523 1.667-1.495 1.85a1.792 1.792 0 0 1-.112.018l.09.073c.687.553 1.32 1.142 1.883 1.723m-4.83-2.89s0 .019.014.032a.051.051 0 0 0 .032.015c.276.009.553.007.834.007.253 0 .508-.003.757-.01.353-.01.517-.196.517-.625 0-.338-.163-.495-.501-.505-.25-.007-.52-.014-.773-.014-.278 0-.56.01-.833.01a.046.046 0 0 0-.033.015c-.017.016-.014.038-.014.038v1.037",
    fill: "url(#world-pay_svg__g)"
  }))));
};

export default SvgWorldPay;